import * as helpers from "./helpers/vnodeHelpers";

export default {
  'extensions/foghour-helpers/vnodeHelpers': helpers,
};
